const state = () => ({
    backup: null, // Ficha original
    preview: null, // Ficha para previsualizar cambios
    form: null, // Formulario para editar parametros
    type: null // Tipo de elemento a editar
})

const getters = {
}

const actions = {
}

const mutations = {
    setEditorForm(state, data) {
        state.form = data
    },
    setEditorType(state, data) {
        state.form = null
        state.type = data
    },
    setEditorBackup(state, data) {

        if (state.backup && state.preview) return

        state.backup = JSON.parse(JSON.stringify(data))
        state.preview = JSON.parse(JSON.stringify(data))
    },
    setEditorPreview(state, data) {

        if (state.type === 'data') {

            state.preview.data[data.key] = JSON.parse(JSON.stringify(data))

        } else if (state.type === 'porlet') {

            let exist = ''
            for (let view in state.preview.view) {
                exist = state.preview.view[view]['cols'].forEach(f => {
                    Object.keys(f.elementos).forEach(elemento => {
                        let encontrado = (f.elementos[elemento].id === data.id) && (f.elementos[elemento].tipo === data.tipo)

                        if (encontrado) {
                            f.elementos[elemento] = JSON.parse(JSON.stringify(data))
                        } else if(!encontrado && f.elementos[elemento].slots) {
                            for(let slot in f.elementos[elemento].slots) {
                                if( (f.elementos[elemento].slots[slot].id === data.id) && (f.elementos[elemento].slots[slot].tipo === data.tipo)) {
                                    f.elementos[elemento].slots[slot] = JSON.parse(JSON.stringify(data))
                                }
                            }
                        }
                    })
                })
            }

        } else if (state.type === 'row') {

            state.preview.view[state.form.nombre].cols = JSON.parse(JSON.stringify(data.cols))
            state.preview.view[state.form.nombre].hook = JSON.parse(JSON.stringify(data.hook))
        }
    },
    setEditorCancel(state) {
        state.backup = null
        state.preview = null
        state.form = null
    }
}

export default {
  state,
  getters,
  actions,
  mutations
}